import { bosdyn_api_msgs } from 'rclnodejs';
import { useState } from 'react';
import { toast } from 'sonner';

import { useRobotArmLoading } from 'store/robot-control';

import { useRosAction, useRosService } from 'hooks/ros';

import { logGreen, logRed } from 'utils/debugger';

import { useSetArmLocked } from '../../../page/manual-control/spot-arm/components/useLockArm';
import { RobotCommandResultParser } from './RobotCommandResultParser';
import { RobotCommandRequest, RobotCommands } from './RobotCommands';

/**
 * the user should use the loading state at least to maybe not trigger the event again?

 * Todo: Remove separations of commands and feedback/results and
 *
 * Todo: code location and naming is not aligned with repository. It comes from a old world where DMs where a thing
 *
 */
export function useSendRobotCommand() {
  const { loading, setLoading } = useRobotArmLoading();
  const { RosActions } = useRosAction();
  const { RosServices } = useRosService();
  const { setArmUnlock } = useSetArmLocked();

  const [result, setResult] = useState('');

  async function sendRobotCommandAction(
    goal: RobotCommandRequest,
    parser: (data: bosdyn_api_msgs.msg.RobotCommandFeedback) => string,
  ) {
    logGreen('🤖🤖🤖sendRobotCommand:goal', goal);
    setLoading(true);
    setResult('');

    // right now we are only sending arm commands but that can change in the future!
    setArmUnlock();

    try {
      // @ts-expect-error - the DeepPartial fun    // @ts-ignore - the DeepPartial function creates "undefined" values in the payloadction creates "undefined" values in the payload
      const response = await RosActions.robotCommand(goal, (feedback) => {
        setResult(parser(feedback.feedback));
      });

      const { success, message, result } = response;

      const statusResult = parser(result);
      setResult(statusResult);

      if (!success) {
        toast.error(message, { description: statusResult });
      }

      return response;
    } catch (error) {
      toast.error('Failed to send robot command', { description: String(error) });
      logRed('sendRobotCommand', { error });
    } finally {
      setLoading(false);
    }
  }

  async function sendRobotCommandService(data: RobotCommandRequest) {
    logGreen('🤖🤖🤖sendRobotCommand', data);
    setLoading(true);
    setResult('');

    // right now we are only sending arm commands but that can change in the future!
    setArmUnlock();

    try {
      // @ts-expect-error - the DeepPartial fun    // @ts-ignore - the DeepPartial function creates "undefined" values in the payloadction creates "undefined" values in the payload
      const response = await RosServices.sendRobotCommand(data);

      const { success, message } = response;

      if (!success) {
        toast.error(message);
      }

      return response;
    } catch (error) {
      toast.error('Failed to send robot command', { description: String(error) });
      logRed('sendRobotCommand', { error });
    } finally {
      setLoading(false);
    }
  }

  /**
   *
   * @param stow - true if we want to stow the arm, false if the arm should become ready
   */
  function sendArmStowCommand(stow: boolean) {
    const goal = RobotCommands.createArmStow(stow);
    return sendRobotCommandAction(goal, RobotCommandResultParser.getArmCarryStowStatus);
  }

  function sendGripperCommand(open: boolean, slow: boolean = false) {
    const goal = RobotCommands.createOpenGripper(open, slow);
    return sendRobotCommandAction(goal, RobotCommandResultParser.getClawGripperStatus);
  }

  function sendArmStopCommand() {
    const goal = RobotCommands.createArmStopCommand();
    return sendRobotCommandAction(goal, RobotCommandResultParser.getArmStopStatus);
  }

  async function sendDragCommand() {
    const data = RobotCommands.createArmDragCommand();
    return sendRobotCommandService(data);
  }

  // loading until parseNamedArmPositionCommandFeedback is 1 STATUS_COMPLETE
  function sendCarryCommand() {
    const data = RobotCommands.createArmCarryCommand();
    return sendRobotCommandService(data);
  }

  return {
    loading,
    result,
    sendArmStowCommand,
    sendGripperCommand,
    sendArmStopCommand,
    sendDragCommand,
    sendCarryCommand,
  };
}
